export default "__VITE_ASSET__BShq8Qk5__"